import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export default {
  getResourcesUsed(currentEvents = []) {
    const eventsWithInput = currentEvents
      .filter((event) => {
        return event.input || event.inputOverride;
      });
    
    return eventsWithInput
      .map((event) => {
        const eventInput = event.inputOverride || event.input;
        const inputName = eventInput.name;

        const overlappingInputs = eventsWithInput.filter((ev) => {
          if (ev.id === event.id) return false;

          const evInput = ev.inputOverride || ev.input;
          if (evInput.id !== eventInput.id) return false;

          const range1 = moment.range(moment.utc(ev.serviceStartTime), moment.utc(ev.serviceEndTime));
          const range2 = moment.range(moment.utc(event.serviceStartTime), moment.utc(event.serviceEndTime));

          return range1.overlaps(range2);
        });

        return {
          ...event,
          inputName: inputName,
          overlappingInputs,
        };
      });
  },

  getOverlappingEvents(events) {
    const activeEvents = events.filter(event => event.status !== 'CANCELLED' && event.status !== 'COMPLETED');

    return activeEvents.map((event) => {
      const {
        serviceStartTime,
        serviceEndTime,
        id,
      } = event;

      const eventRange = moment.range(moment.utc(serviceStartTime), moment.utc(serviceEndTime));

      const related = activeEvents.filter((booking) => {
        if (booking.id === id) return false;
        const bookingRange = moment.range(moment.utc(booking.serviceStartTime), moment.utc(booking.serviceEndTime));
        return eventRange.overlaps(bookingRange);
      });

      const relatedOTT = related.filter((booking) => {
        const { items } = booking.outputs;
        return items.some(out => out && out.output.outputType === 'OTT');
      });

      // Calculate sameOTT (which now includes all output types overlaps)
      const { outputs } = event;
      const mappedOutputs = outputs.items
        .filter((out) => out)
        .map((out) => {
          const ottApplication = out.outputOttApplicationOverride || out.output.ottApplication;
          return {
            id: out.id,
            outputId: out.output.id,
            outputType: out.output.outputType,
            ottApplication,
            ottPlatform: out.output.ottPlatform,
            ottServer: out.output.ottServer,
          };
        });

      const sameOTT = related
        .filter((ev) => {
          const mappedOuts = ev.outputs.items
            .filter((out) => out)
            .map((out) => {
              const ottApplication = out.outputOttApplicationOverride || out.output.ottApplication;
              return {
                id: out.id,
                outputId: out.output.id,
                outputType: out.output.outputType,
                ottApplication,
                ottPlatform: out.output.ottPlatform,
                ottServer: out.output.ottServer,
              };
            })
            .filter((out) => {
              const t = mappedOutputs.filter((output) => {
                if (output.outputType === 'OTT' && out.outputType === 'OTT') {
                  if (!output.ottApplication && !output.ottServer) return false;
                  return output.ottApplication === out.ottApplication && output.ottServer === out.ottServer;
                }
                return output.outputId === out.outputId;
              });
              return t.length > 0;
            });
          return mappedOuts.length > 0;
        });

      return {
        ...event,
        overlapping: related,
        overlappingOTT: relatedOTT,
        sameOTT,
      };
    });
  },
};
